// extracted by mini-css-extract-plugin
export var formContainer = "_ed-0";
export var message = "_ed-1";